<template>
  <svg :style="styles" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 372.03 74.46">
    <g>
      <path d="M102.32,9.65h17.49c15.41,0,25.42,10.44,25.42,25.2s-10,25.21-25.42,25.21H102.32Zm17.49,41.19c9.36,0,14.4-6.55,14.4-16s-5-16-14.4-16h-6.69v32Z"/>
      <path d="M166.89,22.61c11.16,0,18.87,6.91,18.94,17.79a21.16,21.16,0,0,1-.29,3.67H158.9v.14c.43,5.12,3.38,8.29,8.57,8.29,4,0,6.84-1.73,7.7-5h10.08c-1.15,7.28-7.34,13-17,13-12.46,0-19.94-7.42-19.94-18.87S155.73,22.61,166.89,22.61ZM175.61,37c-.65-4.17-3.89-6.48-8.36-6.48-4,0-7.49,2.38-8.06,6.48Z"/>
      <path d="M200.65,9.65V60.06H190.5V9.65Z"/>
      <path d="M242.9,51.34v8.72h-5.18c-5.11,0-6.91-2-7.13-5.26a13,13,0,0,1-11.3,5.69c-8.14,0-14-3.89-14-11,0-8,5.76-12.38,16.63-12.38h7.49V35.5c0-3.09-2.59-5.11-6.7-5.11-3.67,0-6.26,1.73-6.7,4.39h-9.86c.72-7.85,7.27-12.17,17.06-12.17,10.23,0,16.28,4.61,16.28,13.47V49.33c0,1.58.72,2,1.94,2Zm-13.53-7h-7.78c-3.82,0-6.12,1.37-6.12,4.46,0,2.38,2.16,4,5.4,4,5.26,0,8.43-3.17,8.5-8.07Z"/>
      <path d="M251.52,23l8.93,26.29L269.09,23h10.8l-16.27,42.2c-2.38,6.12-4.18,9.22-9.94,9.22h-9.86V65.67h5.9c2.59,0,3.31-.57,4.25-3l1-2.23L240.72,23Z"/>
      <path d="M316.39,9.65v9.43H293.78v11.6h18.51v9.14H293.78V60.06H283V9.65Z"/>
      <path d="M331.11,13.32a5.94,5.94,0,0,1-11.88,0,5.94,5.94,0,0,1,11.88,0ZM330.24,23v37H320.09V23Z"/>
      <path d="M333.43,23h11.74l7.42,10.88L360.22,23h10.94L358.35,41.12,372,60.06H360.36l-8.42-11.81-8.35,11.81H332.64l13.68-18.94Z"/>
    </g>
    <path :class="{ navy }" class="plane" d="M34.72,0A34.73,34.73,0,1,0,69.45,34.72,34.73,34.73,0,0,0,34.72,0ZM58.37,36.84H47.86L37.23,52.17a6.65,6.65,0,0,1-4.95,2.73h-.09l-7.85.44,7.37-18.5H11.35a2,2,0,0,1,0-4H31.8L24.34,14.11l7.94.44a6.62,6.62,0,0,1,4.95,2.73L48,32.83H58.37a2,2,0,0,1,0,4Z"/>
  </svg>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    height: {
      type: Number,
      default: 24
    },
    navy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styles () {
      return {
        height: `${ this.height }px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .navy {
    fill: $navy
  }
</style>
